import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";
import JSONModel from "sap/ui/model/json/JSONModel";
import { CreateBusinessUnitDto } from "../../models/CreateBusinessUnitDto";

/**
 * @namespace akademika.akamont.pages.businessUnitAdd
 */
export default class BusinessUnitAdd extends BaseController {
  route = Routes.BUSINESS_UNIT_ADD;
  parentRoute = Routes.BUSINESS_UNIT_LIST;
  addBusinessUnitUri = "api/BusinessUnit/AddBusinessUnit";

  public async onRouteMatched() {
    this.setModel(new JSONModel({}));
  }

  public async addBusinessUnit() {
    const requestData = this.getModelData<CreateBusinessUnitDto>();

    await this.post(this.addBusinessUnitUri, {
      body: requestData,
    });

    this.navTo(Routes.BUSINESS_UNIT_LIST);
  }
}
